// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestedContentSidebar-cls1_ogz","cls2":"SuggestedContentSidebar-cls2_S5V SuggestedContentSidebar-cls1_ogz"};